import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { uploadDocFileAndRetrieveUrlOperation } from './upload-doc-file-and-retrieve-url-operation';
import { FileUploadFile } from 'primereact/fileupload';

export const addNewFeedbackOperation = async (
  userId: number,
  docId: number,
  comment: string,
  setLoading: (loading: boolean) => any,
  file?: FileUploadFile,
  onFinish?: () => any,
) => {
  try {
    if (comment.length < 3) {
      toast.warn('על התגובה להיות בעלת שלוש תווים לפחות');
      return;
    }

    setLoading(true);

    let fileUrl;
    if (file) {
      fileUrl = await uploadDocFileAndRetrieveUrlOperation(file, userId);
    }
    const asd = await appApi.addDocFeedback(userId, docId, comment, fileUrl);
    setLoading(false);
    onFinish && onFinish();
    toast.success('הוספת התגובה התבצעה בהצלחה');
  } catch (e) {
    setLoading(false);
    toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים');
    console.error(`addNewFeedbackOperation is failed with the error: ${e}`);
  }
};
